"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("@/config/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  name: 'ExtractRequests',
  bodyClass: 'extract-requests-page',
  data: function data() {
    return {
      selected: null,
      type: 'success',
      idService: null,
      service: {},
      selectMonth: null,
      selectYear: null,
      listRequests: [],
      total: 0,
      page: 1,
      perPage: 20,
      now: (0, _moment.default)(),
      filter: '',
      status: '',
      consumer: '',
      listMonths: _constants.LIST_MONTHS,
      listYears: _constants.LIST_YEARS
    };
  },
  watch: {
    selected: function () {
      var _selected = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.$router.push({
                path: "/detail-dashboard-item-list/".concat(val.OperationID)
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function selected(_x) {
        return _selected.apply(this, arguments);
      }
      return selected;
    }(),
    filter: function filter(val) {
      if (val && val.length >= 3) {
        this.getDetailsRequests();
      } else if (!val) {
        this.getDetailsRequests();
      }
    }
  },
  created: function created() {
    var _this$$route$query = this.$route.query,
      status = _this$$route$query.status,
      consumer = _this$$route$query.consumer,
      month = _this$$route$query.month,
      year = _this$$route$query.year;
    var id = this.$route.params.id;
    this.idService = id;
    if (consumer && month && year) {
      this.status = status;
      this.consumer = consumer;
      this.selectMonth = month;
      this.selectYear = year;
      if (this.$route.name === 'ExtractRequestsError') {
        this.type = 'error';
      }
      this.getDetails();
      // clear route
      this.$router.replace({
        query: null
      });
    } else {
      this.goBack();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDetailService', 'fetchServiceTypeID', 'fetchExtractRequestsService'])), {}, {
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.idService) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.fetchDetailService(this.idService);
            case 1:
              data = _context2.v;
              if (data) {
                this.service = data;
                this.getDetailsRequests();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    getDetailsRequests: function () {
      var _getDetailsRequests = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var month, year, data, currentTotal;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.idService) {
                _context3.n = 2;
                break;
              }
              month = this.selectMonth;
              year = this.selectYear;
              _context3.n = 1;
              return this.fetchExtractRequestsService({
                month: month,
                year: year,
                asset: this.idService,
                params: {
                  page: this.page,
                  type: this.type,
                  filter: this.filter,
                  StatusCode: this.status,
                  BusinessUnitId: this.consumer
                }
              });
            case 1:
              data = _context3.v;
              if (data) {
                this.listRequests = data.Rows;
                currentTotal = data.TotalRows;
                if (data.TotalRows / this.perPage > 1000) {
                  currentTotal = this.perPage * 1000;
                }
                this.total = currentTotal;
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getDetailsRequests() {
        return _getDetailsRequests.apply(this, arguments);
      }
      return getDetailsRequests;
    }(),
    goBack: function goBack() {
      var nameReturn = 'requests';
      if (this.$route.name === 'ExtractRequestsError') {
        nameReturn = 'requests-error';
      }
      this.$router.push("/extract/".concat(nameReturn, "/consumer/").concat(this.idService));
    },
    onPageChange: function onPageChange(page) {
      this.page = page;
      this.getDetailsRequests();
    }
  })
};